import React, {Component, ReactElement} from 'react'
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import {Nullable} from '../../../app/TypeHelpers';
import {Location} from 'react-router-dom'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage';
import {NatAsyncCallFunction} from '../../common/util/Natutil';
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo';
import {MESSAGE_TYPE} from '../../../CodeMaster';
import NatSessionRepo from '../session/repository/NatSessionRepo';
import {NatGetServerSessionInfo} from '../session/repository/NatGetServerSessionInfo';
import {Messages} from '../../../Messages';
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo';
import {AdminUserLoginInfo, BelongCondominiumInfo, RelatedAssocUserInfo} from './repository/AdminUserLoginInfo';
import {ApiResponse} from '../../../network/response/ApiResponse';
import {NatAdminLoginInfoSessionStorageHelper} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper';
import {NatGetMenuMasterAuthedAdmin} from '../menuMaster/repository/NatGetMenuMasterAuthedAdmin';
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent';
import AdminAuthRepository from './repository/AdminAuthRepository';
import NatMenuMasterRepo from '../menuMaster/repository/NatMenuMasterRepo';
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo';
import {AdminDialog} from '../../../components/shared/pageBaseComponents/AdminDialog';
import AdminAssocCondominiumSelectionDialogSp from '../../../components/login/AdminAssocCondominiumSelectionDialogSp';
import {Dialog} from '@mui/material';
import AdminAssocCondominiumSelectionDialogPc from '../../../components/login/AdminAssocCondominiumSelectionDialogPc';
import {AppAdminContext} from '../../../app/AppAdminContext';


const KEY_SENI_TYPE = 'seniType';
const KEY_SENI_URL = 'seniUrl';
const ISOWNERSHIPTRANSFER = 'isOwnershipTransfer';
const KEY_SSO_LOGIN_CONDOMINIUM_CD = 'ssoLoginCondominiumCd';
const KEY_SSO_LOGIN_RIDGE_CD = 'ssoLoginRidgeCd';
const KEY_SSO_LOGIN_ROOM_NUMBER = 'ssoLoginRoomNumber';


interface Props {
    location: Location
    residentUserRepo: NatResidentUserRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    adminAuthRepo: AdminAuthRepository
    menuMasterRepo: NatMenuMasterRepo
    sessionRepo: NatSessionRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
}

interface State {
    condominiumSelectDialogOpen: boolean
    belongCondominiumInfoList: BelongCondominiumInfo[]
}

class NatAssocAfterLoginCushion extends Component<Props & ResidentPagePropsSet, State> {
    declare context: React.ContextType<typeof AppAdminContext>
    seniUrl: Nullable<string>;
    seniType: Nullable<string>;
    ssoLoginCondominiumCd: Nullable<string>;
    ssoLoginRidgeCd: Nullable<string>;
    ssoLoginRoomNumber: Nullable<string>;

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props);

        this.state = {
            condominiumSelectDialogOpen: false,
            belongCondominiumInfoList: []
        }
        this.seniUrl = SessionStorageHelper.getStringItemOrNull(KEY_SENI_URL);
        this.seniType = SessionStorageHelper.getStringItemOrNull(KEY_SENI_TYPE);
        this.ssoLoginCondominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_CONDOMINIUM_CD);
        this.ssoLoginRidgeCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_RIDGE_CD);
        this.ssoLoginRoomNumber = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_ROOM_NUMBER);
        this.handleCondominiumSelectButtonClick = this.handleCondominiumSelectButtonClick.bind(this);
        this.handleCloseForCondominiumSelectDialog = this.handleCloseForCondominiumSelectDialog.bind(this);
    }

    async componentDidMount(): Promise<void> {
        // サーバ側のセッション情報を取得
        const sessionInfoForLoginPage: Nullable<NatGetServerSessionInfo> = await NatAsyncCallFunction(
            this.props.residentUserRepo.getBackendSessionInfo.bind(this.props.residentUserRepo),
            this.props.navigate, this.systemErrorTransition
        )
        let loginPage = null;
        if (sessionInfoForLoginPage && sessionInfoForLoginPage.loginPage) {
            loginPage = sessionInfoForLoginPage.loginPage
        }
        // 管理組合ログイン
        if ('NatAdminAssocLoginPage' === loginPage) {
            // サーバ側のセッション情報を取得
            try {
                if (sessionInfoForLoginPage && sessionInfoForLoginPage.belongCondominiumInfoList) {
                    const assocUserLoginInfo: RelatedAssocUserInfo = {
                        details: sessionInfoForLoginPage.belongCondominiumInfoList
                    }

                    if (assocUserLoginInfo.errorInfo && assocUserLoginInfo.errorInfo.detailMessage) {
                        this.systemErrorTransition()
                        return
                    }

                    const belongCondominiumInfoList = assocUserLoginInfo.details
                    if (belongCondominiumInfoList === undefined || belongCondominiumInfoList.length === 0) {
                        return
                    }

                    if (belongCondominiumInfoList.length === 1) {
                        await this.selectLoginUser(belongCondominiumInfoList[0].condominiumCd)
                    } else {
                        this.setState({
                            belongCondominiumInfoList,
                            condominiumSelectDialogOpen: true,
                        })
                    }
                }
            } catch (e) {
                this.systemErrorTransition()
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        } else {
            this.systemErrorTransition()
        }
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`,
            {
                state: {
                message: Messages.ESYCC0015.toString(),
                nonDisplayBackBtnFlag: SessionStorageHelper.getStringItemOrNull(ISOWNERSHIPTRANSFER) ?? ''
                }
            })
    }

    async selectLoginUser(condominiumCd: string): Promise<void> {
        const {
            adminAuthRepo,
            menuMasterRepo,
            navigate,
            location,
            eventEmitter,
        } = this.props

        // CSRFトークンを設定するために、GETのAPIを実行
        await NatAsyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            this.props.navigate, this.systemErrorTransition
        )

        const adminUserLoginInfoBean: Nullable<ApiResponse<AdminUserLoginInfo>> = await NatAsyncCallFunction(
            adminAuthRepo.selectAssocUser.bind(
                adminAuthRepo,
                condominiumCd,
            ),
            this.props.navigate, this.systemErrorTransition
        )

        if (adminUserLoginInfoBean == null || adminUserLoginInfoBean.details == null) {
            return
        }

        NatAdminLoginInfoSessionStorageHelper.setSessionStorage(adminUserLoginInfoBean.details)

        let nextUrl: { pathname?: string, search?: string } = {}
        if (this.seniUrl) {
            nextUrl = {
                pathname: this.seniUrl.split('?')[0],
                search: this.seniUrl.split('?')[1],
            }
        }
        if (!nextUrl.pathname) {
            // 一番左（最初）のメニューを取得
            const menuInfo: Nullable<NatGetMenuMasterAuthedAdmin> = await NatAsyncCallFunction(
                menuMasterRepo.getMenuMasterAuthedAdmin.bind(menuMasterRepo),
                this.props.navigate, this.systemErrorTransition
            )
            if (menuInfo === null) {
                return
            }

            nextUrl.pathname = menuInfo.details?.[0]?.childMenuInfo?.[0]?.url
            if (!nextUrl.pathname) {
                // メニューが取得できない場合はエラー表示する
                this.setState({condominiumSelectDialogOpen: false})
                const headingAreaMessageParams: HeadingAreaMessageParams = {
                    messageLevel: MESSAGE_TYPE.ERROR,
                    title: null,
                    detail: '物件に利用できる機能がないため、ログインできませんでした。',
                }
                await this.props.eventEmitter.showHeadingAreaMessage(headingAreaMessageParams)
                await this.logoutProcedure()
                return
            }
        }
        navigate(nextUrl)
    }

    async logoutProcedure(): Promise<void> {
        // NOTE: 機会があるときにAdminSessionUtilのログアウト処理に統合する
        await this.props.eventEmitter.showLoading()
        try {
            await NatAsyncCallFunction(
                this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                this.props.navigate, this.systemErrorTransition
            )
            await NatAsyncCallFunction(
                this.props.sessionRepo.postAdminUseSite.bind(this.props.sessionRepo),
                this.props.navigate, this.systemErrorTransition
            )
            SessionStorageHelper.removeAllItem()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleCloseForCondominiumSelectDialog = async () => {
        try {
            await NatAsyncCallFunction(
                this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                this.props.navigate, this.systemErrorTransition)
        } finally {
            this.setState({condominiumSelectDialogOpen: false})
            this.props.navigate('/admin/assoc/login')
        }
    }

    async handleCondominiumSelectButtonClick(condominiumCd: string): Promise<void> {
        await this.selectLoginUser(condominiumCd)
    }

    render(): ReactElement {
        const {
            condominiumSelectDialogOpen,
            belongCondominiumInfoList
        } = this.state

        const spMode = this.context.showSpModePage

        return (
            <>
                {condominiumSelectDialogOpen &&
                spMode ?
                    <AdminDialog open={condominiumSelectDialogOpen}>
                        <AdminAssocCondominiumSelectionDialogSp
                            belongCondominiumInfoList={belongCondominiumInfoList}
                            handleCondominiumSelectButtonClick={this.handleCondominiumSelectButtonClick}
                            handleCloseForCondominiumSelectDialog={this.handleCloseForCondominiumSelectDialog}
                        />
                    </AdminDialog>
                    :
                    <Dialog
                        id={'pp-dialog'}
                        open={condominiumSelectDialogOpen}
                        transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                        maxWidth={'md'}
                        fullWidth
                    >
                        <AdminAssocCondominiumSelectionDialogPc
                            belongCondominiumInfoList={belongCondominiumInfoList}
                            handleCondominiumSelectButtonClick={this.handleCondominiumSelectButtonClick}
                            handleCloseForCondominiumSelectDialog={this.handleCloseForCondominiumSelectDialog}
                        />
                    </Dialog>
                }
            </>
        )
    }
}

export default createResidentPage(NatAssocAfterLoginCushion)
